let project_list = [
	{
		image:
			'https://i.ibb.co/vxhzcnR/Whats-App-Image-2021-03-27-at-3-00-56-PM-1.jpg',
		title: 'Android, ios Shop',
		des:
			"Android ios Shopping App for users to buy clothes straight from their phone and have them delivered to their door step",
		tags: [ 'React Native', 'Firebase', 'JavaScript' ],
		links: {
			launch: 'https://github.com/douglasmaringa/Android-Shop',
			github: 'https://github.com/douglasmaringa/Android-Shop'
		}
	},
	{
		image:
			'https://i.ibb.co/N1CkyhM/Whats-App-Image-2021-03-17-at-6-54-30-PM-2.jpg',
		title: 'Food Ordering android, ios app',
		des:
			"React Native Food Ordering App for Android and ios.",
		tags: [ 'React Native','Redux', 'Firebase', 'JavaScript' ],
		links: {
			launch: 'https://github.com/douglasmaringa/Food-Ordering-App',
			github: 'https://github.com/douglasmaringa/Food-Ordering-App'
		}
	},
	{
		image:
			'https://project-images.gitconnectedcontent.com/f9f12c92-47a8-429d-88e6-94bc1a4017de-desktop',
		title: 'Amazon Clone',
		des:
			"Amazon clone built using React, React-Router, Firebase for authentication, context-api to share state to the shopping cart and material ui for the design .",
		tags: [ 'HTML', 'CSS', 'React', 'Context Api','Firebase', 'JavaScript' ],
		links: {
			launch: 'https://clone-85412.web.app/',
			github: 'https://github.com/douglasmaringa/Amazon-clone'
		}
	},
	{  /* -------------------------------- */
		image:
			'https://i.ibb.co/TYt58nv/Capture.png',
		title: 'Soundwave Design Concept',
		des:
			"A UI/UX design of a music streaming web application made using figma and then converted to html and css.",
		tags: [  'FIGMA','HTML','CSS' ],
		links: {
			launch: 'https://github.com/douglasmaringa',
			github: 'https://github.com/douglasmaringa'
		}
	},
	{  /* -------------------------------- */
		image:
			'https://project-images.gitconnectedcontent.com/e07adb1d-001a-411b-8c70-23eb03616249-desktop',
		title: 'zimbabwe-bank-locator',
		des:
			"A web-app that allows you to search the location of banks in zimbabwe",
		tags: [ 'CSS', 'React', 'JavaScript' ],
		links: {
			launch: 'https://nervous-snyder-3033dd.netlify.app/',
			github: 'https://github.com/douglasmaringa/zimbabwe-bank-locator-frontend'
		}
	},
	{
		image:
			'https://project-images.gitconnectedcontent.com/1c439721-9d47-4304-8929-aa341e4ffc89-desktop',
		title: 'Chat Web App',
		des:
			"chat up made with react js and firebase backend ",
		tags: [ 'HTML', 'CSS', 'Javascript','firebase','ReactJs' ],
		links: {
			launch: 'https://elastic-murdock-40f419.netlify.app/',
			github: 'https://github.com/douglasmaringa/React-Chat-Messenger-app'
		}
	},
	{  /* -------------------------------- */
		image:
			'https://project-images.gitconnectedcontent.com/152088cf-329e-43f1-94ff-e0c2527b4db5-desktop',
		title: 'Recipe App',
		des:
			"React App that allows the user to enter any food they want to make and it brings back the recipe.",
		tags: [ 'CSS', 'React', 'JavaScript' ],
		links: {
			launch: 'https://recipe-app-71027.web.app/',
			github: 'https://github.com/douglasmaringa/Recipe-App'
		}
	},
	{/* -------------------------------- */
		image:
			'https://project-images.gitconnectedcontent.com/2a09beef-c266-4c68-97d9-d7049b6dbd92-desktop',
		title: 'Netflix Trailer App',
		des:
			"Netflix trailer app built using React , tmdb api and react youtube",
		tags: [ 'React', 'HTML', 'CSS', 'JavaScript' ],
		links: {
			launch: 'https://netflix-clone-d66da.web.app/',
			github: 'https://github.com/douglasmaringa/Netflix-clone'
		}
	}
];

export default project_list;
